import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import Modal from "react-modal";
import CloseIcon from "@mui/icons-material/Close";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import { useGlobalContext } from "../../../Context/GlobalContext";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import SearchIcon from "@mui/icons-material/Search";
import Cookies from "js-cookie";
import { FaEdit } from "react-icons/fa";
import { MdDelete } from "react-icons/md";

const EditLeavePolicies = () => {
  const { id } = useParams();
  const [activeTab, setActiveTab] = useState("leave-requests");
  const [activeSubTab, setActiveSubTab] = useState("pending");
  const [isLoading, setIsLoading] = useState(false);
  const { baseUrl, selectedStaff, openToast, branchData } = useGlobalContext();
  const [staff, setStaff] = useState(null);
  const [selectDuration, setSelectDuration] = useState("MONTHLY");
  const [editingRow, setEditingRow] = useState(null);
  const [leavePolicyType, setLeavePolicyType] = useState();
  const [allowedLeavesPerYear, setAllowedLeavePerYear] = useState();
  const [carryForwardLeaves, setCarryForwardLeaves] = useState();
  const [editLeaveID, setEditLeaveID] = useState(null);
  const [deleteLeaveID, setDeleteLeaveID] = useState(null);
  const [editLeaveStatus, setEditLeaveStatus] = useState("");
  const [editLeaveStartDate, setEditLeaveStartDate] = useState("");
  const [editLeaveEndDate, setEditLeaveEndDate] = useState("");
  const [editLeaveRequestDate, setEditLeaveRequestDate] = useState("");
  const [saveLeaveRequestEdit, setSaveLeaveRequestEdit] = useState("");

  const [fetchAllLeaveRequest, setFetchAllLeaveRequest] = useState([]);
  const [updateLeaveBalance, setUpdateLeaveBalance] = useState(
    selectedStaff?.staffDetails?.LeaveBalance?.map((item) => ({
      balance: item?.balance,
      leaveName: selectedStaff?.staffDetails?.LeavePolicy?.find(
        (policy) => policy?.id === item?.leavePolicyId
      )?.name,
      used: item?.used,
      id: item?.id,
    }))
  );

  const [fetchLeavePolicy, setFetchLeavePolicy] = useState(
    selectedStaff?.staffDetails?.LeavePolicy || []
  );

  const [updatePolicy, setUpdatePolicy] = useState({
    allowed_leaves: 0,
    carry_forward_leaves: 0,
  });

  console.log(updatePolicy);

  const getData = async (e) => {
    try {
      const response = await fetch(baseUrl + "staff/", {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${Cookies.get("flowChangerAuthToken")}`,
        },
      });

      if (response.status === 200) {
        const result = await response.json();
        // console.log(result);
        const filteredData = result.filter(
          (item) => item.id === selectedStaff.id
        )[0];
        setStaff(filteredData);
        setUpdateLeaveBalance(
          filteredData?.staffDetails?.LeaveBalance?.map((item) => ({
            balance: item?.balance,
            leaveName: filteredData?.staffDetails?.LeavePolicy?.find(
              (policy) => policy?.id === item?.leavePolicyId
            )?.name,
            used: item?.used,
            id: item?.id,
          }))
        );
        setFetchLeavePolicy(filteredData?.staffDetails?.LeavePolicy);
        // console.log("Filtered data by ID:", filteredData);
      } else {
        console.error(
          "Failed to retrieve data:",
          response.status,
          response.statusText
        );
      }
    } catch (error) {
      console.error("An error occurred while fetching data:", error);
    }
  };

  useEffect(() => {
    getData();
  }, []);
  console.log(updateLeaveBalance);

  // console.log(updateLeaveBalance);
  const updatedLeaveBalance = async () => {
    setIsLoading(true);
    try {
      const allData = [];
      for (const data of updateLeaveBalance) {
        const response = await fetch(baseUrl + "leave-balance/" + data?.id, {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${Cookies.get("flowChangerAuthToken")}`,
          },
          body: JSON.stringify({
            ...data,
            balance: Number(data?.balance),
            used: Number(data?.used),
            policy_type: selectDuration,
          }),
        });
        const result = await response.json();
        if (response.status === 200) {
          allData.push(result);
        }
      }
      if (allData.length > 0) {
        console.log(allData);
        openToast("Leave Balance updated Successfully", "success");
      } else {
        openToast("An error occurred while updating leave balance", "error");
      }
    } catch (error) {
      console.error("Error updating leave balance:", error);
      openToast("An error occurred while updating leave balance", "error");
    } finally {
      setIsLoading(false);
    }
  };

  // console.log(fetchLeavePolicy);
  // console.log(updatePolicy);

  // console.log(selectDuration, leavePolicyType, allowedLeavesPerYear, carryForwardLeaves);
  async function createLeavePolicy(e) {
    e.preventDefault();
    if (!leavePolicyType || !allowedLeavesPerYear || !carryForwardLeaves) {
      if (!leavePolicyType) {
        openToast("Please enter leave policy name", "warning");
      } else if (!allowedLeavesPerYear) {
        openToast(
          `Please enter allowed leaves ${
            selectDuration === "MONTHLY" ? "per month" : "per year"
          }`,
          "warning"
        );
      } else if (!carryForwardLeaves) {
        openToast(
          `Please enter carry forward leaves ${
            selectDuration === "MONTHLY" ? "at end month" : "at end year"
          }`,
          "warning"
        );
      }
      return;
    }
    setIsLoading(true);
    const data = {
      policy_type: selectDuration,
      name: leavePolicyType,
      allowed_leaves: Number(allowedLeavesPerYear),
      carry_forward_leaves: Number(carryForwardLeaves),
    };

    console.log(data);

    try {
      const response = await fetch(
        baseUrl + "leave-policy/" + selectedStaff?.staffDetails?.id,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${Cookies.get("flowChangerAuthToken")}`,
          },
          body: JSON.stringify(data),
        }
      );
      console.log(response);

      const result = await response.json();
      console.log(result);
      if (response.ok) {
        console.log(result);
        setFetchLeavePolicy([...fetchLeavePolicy, result]);
        setUpdateLeaveBalance([
          ...updateLeaveBalance,
          {
            leaveName: result?.name,
            balance: Number(result?.leaveBalance?.balance),
            used: result?.leaveBalance?.used,
            id: result?.leaveBalance?.id,
          },
        ]);
        setLeavePolicyType("");
        setAllowedLeavePerYear("");
        setCarryForwardLeaves("");
        openToast("Leave Policy created Successfully", "success");
        closeModal12();
      } else {
        openToast(
          result.message ||
            result.details ||
            "An error occurred while creating leave policy",
          "error"
        );
      }
    } catch (error) {
      console.error("Error creating leave policy:", error);
      openToast(
        error.message ||
          error.details ||
          "An error occurred while creating leave policy",
        "error"
      );
    } finally {
      setIsLoading(false);
    }
  }

  async function updateLeavePolicy(e) {
    setIsLoading(true);
    e.preventDefault();

    const data = {
      policy_type: selectDuration,
      name: leavePolicyType,
      allowed_leaves: Number(updatePolicy.allowed_leaves || 0),
      carry_forward_leaves: Number(updateLeavePolicy.carry_forward_leaves || 0),
    };

    console.log(data);

    try {
      const response = await fetch(baseUrl + "leave-policy/" + editingRow, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${Cookies.get("flowChangerAuthToken")}`,
        },
        body: JSON.stringify(data),
      });
      console.log(response);

      const result = await response.json();
      if (response.status === 200) {
        console.log(result);

        setFetchLeavePolicy(
          fetchLeavePolicy.map((item) =>
            item.id === editingRow ? result : item
          )
        );
        closeModal12();
        openToast("Leave Policy updated Successfully", "success");
      } else {
        openToast(
          result.message ||
            result.details ||
            "An error occurred while creating leave policy",
          "error"
        );
      }
    } catch (error) {
      console.error("Error updating leave policy:", error);
      openToast(
        error.message ||
          error.details ||
          "An error occurred while creating leave policy",
        "error"
      );
    } finally {
      setIsLoading(false);
      setEditingRow(null);
    }
  }

  async function getAllLeaveRequest() {
    try {
      const response = await fetch(
        baseUrl + "leave-request/" + selectedStaff?.staffDetails?.id,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${Cookies.get("flowChangerAuthToken")}`,
          },
        }
      );
      console.log(response);

      const result = await response.json();
      if (response.status === 200) {
        console.log(result);
        setFetchAllLeaveRequest(result);
      } else {
        console.log(result);
      }
    } catch (error) {
      console.error("Error retrieving leave requests:", error);
    }
  }

  async function deleteLeaveRequest(e, id) {
    e.preventDefault();
    try {
      const response = await fetch(baseUrl + "leave-request/" + id, {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${Cookies.get("flowChangerAuthToken")}`,
        },
      });
      console.log(response);

      const result = await response.json();
      if (response.status === 200) {
        console.log(result);
        setDeleteLeaveID(null);
        openToast("Leave Request deleted Successfully", "success");
      } else {
        openToast("An error occurred while deleting leave request", "error");
      }
    } catch (error) {
      console.error("Error deleting leave request:", error);
      openToast("An error occurred while deleting leave request", "error");
    }
  }

  async function editLeaveRequest(e, id) {
    setIsLoading(true);
    e.preventDefault();
    const data = {
      staffId: selectedStaff?.staffDetails?.id,
      leaveTypeId: editLeaveID,
      request_date: new Date(editLeaveRequestDate).toISOString(),
      start_date: new Date(editLeaveStartDate).toISOString(),
      end_date: new Date(editLeaveEndDate).toISOString(),
      status: editLeaveStatus,
    };

    try {
      const response = await fetch(baseUrl + "leave-request/" + id, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${Cookies.get("flowChangerAuthToken")}`,
        },
        body: JSON.stringify(data),
      });
      console.log(response);

      const result = await response.json();
      if (response.status === 200) {
        console.log(result);

        fetchAllLeaveRequest.map((item) => {
          if (item.id === saveLeaveRequestEdit) {
            item.status = editLeaveStatus;
            item.start_date = editLeaveStartDate;
            item.end_date = editLeaveEndDate;
            item.request_date = editLeaveRequestDate;
          }
        });
        setEditLeaveID("");
        setEditLeaveStatus("");
        setEditLeaveStartDate("");
        setEditLeaveEndDate("");
        setEditLeaveRequestDate("");
        setSaveLeaveRequestEdit("");
        openToast("Leave Request updated Successfully", "success");
      } else {
        openToast("An error occurred while updating leave request", "error");
      }
    } catch (error) {
      console.error("Error updating leave request:", error);
      openToast("An error occurred while updating leave request", "error");
    } finally {
      setIsLoading(false);
    }
  }

  console.log(deleteLeaveID);

  let subtitle;
  // when onclick update staff
  const [modalIsOpen10, setIsOpen10] = React.useState(false);
  function openModal10() {
    setIsOpen10(true);
  }
  function afterOpenModal10() {
    // references are now sync'd and can be accessed.
    subtitle.style.color = "#000";
  }

  function closeModal10() {
    setIsOpen10(false);
  }
  // when onclick update staff

  // when on click update leave policiy
  const [modalIsOpen12, setIsOpen12] = React.useState(false);
  function openModal12() {
    setIsOpen12(true);
  }
  // function afterOpenModal12() {
  //     // references are now sync'd and can be accessed.
  //     subtitle.style.color = '#000';
  // }

  function closeModal12() {
    setIsOpen12(false);
  }
  // when on click update leave policy

  const [isOpenLeaveRequestModal, setIsOpenLeaveRequestModal] = useState(false);

  /**
   * Opens the leave request modal by setting the state to true.
   */
  function openLeaveRequestModal() {
    setIsOpenLeaveRequestModal(true);
  }

  function afterOpenLeaveRequestModal() {
    // references are now sync'd and can be accessed.
    subtitle.style.color = "#000";
  }
  /**
   * Close the leave request modal
   **/

  function closeOpenLeaveRequestModal() {
    setIsOpenLeaveRequestModal(false);
  }

  const formatDate = (isoString) => {
    const date = new Date(isoString);
    const options = {
      // weekday: 'long',  // e.g., "Sunday"
      year: "numeric", // e.g., "2024"
      month: "long", // e.g., "October"
      day: "numeric", // e.g., "27"
      // hour: '2-digit',  // e.g., "05"
      // minute: '2-digit', // e.g., "30"
      // second: '2-digit', // e.g., "00"
      // hour12: true      // e.g., "AM/PM"
    };
    return date.toLocaleString("en-US", options);
  };

  const formatDateToInput = (date) => {
    const d = new Date(date);
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, "0"); // Month is zero-indexed
    const day = String(d.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  useEffect(() => {
    getAllLeaveRequest();
  }, [saveLeaveRequestEdit, deleteLeaveID]);

  return (
    <div className="relative flex flex-col xl:pt-[30px] pb-[30px] w-full">
      <div className="top-0 flex justify-between items-center bg-white shadow-cs pt-[14px] pr-[14px] pb-[14px] pl-[14px] rounded-md w-[100%]">
        <h3 className="font-medium">Leave & Balance Details</h3>
        <button className="second-btn">Update Details</button>
      </div>

      <div className="mt-5">
        <button
          className="flex justify-between items-center bg-white shadow-cs mb-4 p-4 rounded-lg w-full text-[#000] text-[14px] text-start"
          onClick={openModal12}
        >
          {" "}
          Leave Policy <ArrowForwardIosIcon className="allarrow-verify" />
        </button>
        <button
          className="flex justify-between items-center bg-white shadow-cs mb-4 p-4 rounded-lg w-full text-[#000] text-[14px] text-start"
          onClick={openModal10}
        >
          {" "}
          Leave Balances <ArrowForwardIosIcon className="allarrow-verify" />
        </button>
        <button
          className="flex justify-between items-center bg-white shadow-cs mb-4 p-4 rounded-lg w-full text-[#000] text-[14px] text-start"
          onClick={openLeaveRequestModal}
        >
          {" "}
          Leave Request <ArrowForwardIosIcon className="allarrow-verify" />
        </button>
      </div>

      {/* when onclick update staff */}

      <Modal
        isOpen={modalIsOpen10}
        // onAfterOpen={afterOpenModal12}
        onRequestClose={closeModal10}
        // style={customStyles}
        contentLabel="Example Modal"
        className="top-[50%] bottom-auto left-[50%] absolute bg-[#fff] shadow-cs p-[20px] rounded-[10px] w-[96%] xl:w-[40%] h-[auto] translate-x-[-50%] translate-y-[-50%]"
      >
        {/* <h2 ref={(_subtitle) => (subtitle = _subtitle)} className='bg-[#F0F6FE] p-3 border-b rounded-b-none rounded-r-lg rounded-t-lg text-[14px] text-center'>Update Leave Balances for all Staff</h2> */}
        <button
          onClick={closeModal10}
          className="top-[3px] right-[5px] absolute bg-[#27004a] rounded-full font-semibold"
        >
          <CloseIcon className="text-white" />
        </button>
        <div className="">
          <div className="flex justify-between items-center mb-[24px] border-t-0 border-r-0 text-[13px] xl:text-[14px]">
            <div className="flex items-center gap-[20px] pb-[10px] border-b w-full">
              <h4 className="m-0 font-medium text-[12px] text-[27004a] xl:text-[14px]">
                Leave & Balance Details{" "}
              </h4>
              <p className="font-medium"> Leave Balance</p>
            </div>
          </div>

          <div className="border-grey-200 bg-[#fff] shadow-cs mb-3 border rounded-md">
            <div className="grid grid-cols-2">
              <div className="p-[8px] border-r font-medium text-[15px] text-center text-gray-700">
                Leave Type
              </div>
              <div className="p-[8px] font-medium text-[15px] text-center text-gray-700 whitespace-nowrap">
                Remaining Balance
              </div>
            </div>
          </div>
          {updateLeaveBalance?.map((item, index) => (
            <div className="items-center gap-4 border-[#dbdbdb]  bg-[#fff] mb-[14px]  border rounded-md"> 
            <div
              key={item?.id}
              className="grid grid-cols-2"
            >
              <div className="p-[8px] border-r font-medium text-[13px] flex items-center justify-center text-gray-700">
                {" "}
                {item?.leaveName} Leaves
              </div>
              <div className="p-[8px] font-medium text-[14px] text-center text-gray-700 whitespace-nowrap">
                <input
                  value={item?.balance}
                  onChange={(e) =>
                    setUpdateLeaveBalance((prev) =>
                      prev.map((obj, idx) =>
                        idx === index
                          ? { ...obj, balance: e.target.value }
                          : obj
                      )
                    )
                  }
                  type="number"
                  placeholder="1"
                  className="bg-white px-3 py-1 border rounded-md text-[13px] w-32 focus-visible:outline-none newsetup3"
                />
              </div>
            </div>
            </div>
          ))}
          {/* <div className="items-center gap-4 border-[#cbcbcb] grid grid-cols-2 bg-[#fafafa] mb-[14px] p-[8px] border rounded-md">
                        <div className="font-medium text-[15px] text-gray-700">Privileged Leave</div>
                        <div className="flex items-center gap-2">
                            <input
                                type="text"
                                placeholder='1'
                                className="bg-white px-3 py-1 border rounded-md w-32 focus-visible:outline-none"
                            />
                            <span className="font-medium text-[15px] text-gray-600">leaves</span>
                        </div>
                    </div> */}
          <div className="flex justify-center items-center">
            <button
              disabled={isLoading}
              onClick={updatedLeaveBalance}
              className={
                "whitespace-nowrap  p-[8px] second-btn " +
                (isLoading && "opacity-50 cursor-not-allowed animate-pulse")
              }
            >
              Update Details
            </button>
          </div>
        </div>
      </Modal>

      {/* when onclick update staff
       */}

      {/* when onclick leave policies
       */}
      <Modal
        isOpen={modalIsOpen12}
        // onAfterOpen={afterOpenModal12}
        onRequestClose={closeModal12}
        contentLabel="Example Modal"
        className="top-[50%] bottom-auto left-[50%] absolute bg-[#fff] shadow-cs p-0 rounded-[10px] w-[96%] xl:w-[40%] translate-x-[-50%] translate-y-[-50%]"
      >
        <h2
          ref={(_subtitle) => (subtitle = _subtitle)}
          className="p-3 border-b rounded-b-none rounded-r-lg rounded-t-lg text-[14px]"
        >
          Update Leave Policy for staff
        </h2>
        <button
          onClick={closeModal12}
          className="top-[3px] right-[5px] absolute bg-[#27004a] rounded-full font-semibold"
        >
          <CloseIcon className="bg-[#27004a] rounded-2xl text-white" />
        </button>
        <div className="pb-2">
          <Tabs className="fixed-tab-section p-[s0px]">
            <TabList className="flex justify-around items-center bg-[#F4F5F9] m-2 xl:m-2 mt-3 mb-2 pt-[10px] pb-[10px] rounded-md">
              <label className="text-[14px]">Select Type</label>
              <Tab className="flex items-center gap-[10px] cursor-pointer">
                <input
                  checked={selectDuration === "MONTHLY"}
                  onChange={(e) => setSelectDuration("MONTHLY")}
                  value={"Month"}
                  type="radio"
                  id="fixed"
                  name="fixed"
                  className="rounded-full"
                />
                <label for="fixed" className="text-[14px]">
                  {" "}
                  Monthly
                </label>
                <br />
              </Tab>
              <Tab className="flex items-center gap-[10px] cursor-pointer">
                <input
                  checked={selectDuration === "YEARLY"}
                  onChange={(e) => setSelectDuration("YEARLY")}
                  value={"Year"}
                  type="radio"
                  id="flexible"
                  name="fixed"
                  className="rounded-full"
                />
                <label for="flexible" className="text-[14px]">
                  {" "}
                  Yearly
                </label>
                <br />
              </Tab>
            </TabList>
            <TabPanel>
              <div className="flex border-1 mt-4 p-[10px] pr-3 pl-3 border w-[100%] overflow-x-scroll">
                <table className="border-[#dbdbdb] mt-4 border rounded-md table-section">
                  <thead className="top-[-1px] sticky border-[#dbdbdb] bg-white border cursor-pointer">
                    <tr>
                      <th className="leavetype-radius">Leave Type</th>
                      <th>Allowed Leaves (Per Month)</th>
                      <th>Carry-forward Leaves (On Month End)</th>
                    </tr>
                  </thead>
                  <tbody>
                    {fetchLeavePolicy
                      ?.filter(({ policy_type }) => policy_type === "MONTHLY")
                      ?.map(
                        ({
                          id,
                          carry_forward_leaves,
                          allowed_leaves,
                          name,
                        }) => (
                          <tr className="border border-[#dbdbdb]" key={id}>
                            <td
                              className="border-r"
                              onClick={() => {
                                console.log(id);
                                setEditingRow(id);
                                setUpdatePolicy({
                                  carry_forward_leaves,
                                  allowed_leaves,
                                });
                                setLeavePolicyType(name);
                              }}
                            >
                              {name}
                            </td>
                            <td className="border-r">
                              {editingRow === id ? (
                                <input
                                  className="text-center"
                                  type="number"
                                  value={updatePolicy.allowed_leaves}
                                  onChange={(e) =>
                                    setUpdatePolicy((prev) => {
                                      return {
                                        ...prev,
                                        allowed_leaves: e.target.value,
                                      };
                                    })
                                  }
                                  autoFocus
                                />
                              ) : (
                                allowed_leaves
                              )}
                            </td>

                            {/* Editable Carry Forward Leaves Field */}
                            <td>
                              {editingRow === id ? (
                                <input
                                  className="text-center"
                                  type="number"
                                  value={updatePolicy.carry_forward_leaves}
                                  onChange={(e) =>
                                    setUpdatePolicy((prev) => {
                                      return {
                                        ...prev,
                                        carry_forward_leaves: e.target.value,
                                      };
                                    })
                                  }
                                />
                              ) : (
                                carry_forward_leaves
                              )}
                            </td>
                          </tr>
                        )
                      )}
                    <tr>
                      <td className="border-r">
                        <input
                          className="border-[#dbdbdb] bg-[#fff] py-2 border rounded-md text-center placeholder:text-center focus:outline-none newsetup3 outline-none"
                          placeholder="New Policy Type"
                          value={leavePolicyType}
                          onChange={(e) => setLeavePolicyType(e.target.value)}
                          type="text"
                        />
                      </td>
                      <td className="border-r">
                        <input
                          className="border-[#dbdbdb] bg-[#fff] py-2 border rounded-md text-center placeholder:text-center focus:outline-none newsetup3 outline-none"
                          placeholder="Set Allowed Leaves"
                          value={allowedLeavesPerYear}
                          onChange={(e) =>
                            setAllowedLeavePerYear(e.target.value)
                          }
                          type="text"
                        />
                      </td>
                      <td className="border-r">
                        <input
                          className="border-[#dbdbdb] bg-[#fff] py-2 border rounded-md w-2/3 text-center placeholder:text-center focus:outline-none newsetup3 outline-none"
                          placeholder="Set Carry Forward Leaves"
                          value={carryForwardLeaves}
                          onChange={(e) =>
                            setCarryForwardLeaves(e.target.value)
                          }
                          type="text"
                        />
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </TabPanel>
            <TabPanel>
              <div className="flex border-1 mt-4 p-[10px] pr-3 pl-3 border w-[100%] overflow-x-scroll">
                <table className="border-[#dbdbdb] mt-4 border rounded-md table-section">
                  <thead className="top-[-1px] sticky border-[#dbdbdb] bg-white border cursor-pointer">
                    <th>Leave Type</th>
                    <th>Allowed Leaves (Per Year)</th>
                    <th>Carry-forward Leaves (On Year End)</th>
                  </thead>
                  <tbody>
                    {fetchLeavePolicy
                      ?.filter(({ policy_type }) => policy_type === "YEARLY")
                      ?.map(
                        ({
                          id,
                          carry_forward_leaves,
                          allowed_leaves,
                          name,
                        }) => (
                          <tr key={id}>
                            <td
                              className="border-r"
                              onClick={() => {
                                // console.log(id);
                                // console.log(name);
                                setEditingRow(id);
                                setUpdatePolicy({
                                  carry_forward_leaves,
                                  allowed_leaves,
                                });
                                setLeavePolicyType(name);
                              }}
                            >
                              {name}
                            </td>
                            <td className="border-r w-full">
                              {editingRow === id ? (
                                <input
                                  className="text-center"
                                  type="number"
                                  value={updatePolicy.allowed_leaves}
                                  onChange={(e) =>
                                    setUpdatePolicy((prev) => {
                                      return {
                                        ...prev,
                                        allowed_leaves: e.target.value,
                                      };
                                    })
                                  }
                                  autoFocus
                                />
                              ) : (
                                allowed_leaves
                              )}
                            </td>

                            {/* Editable Carry Forward Leaves Field */}
                            <td>
                              {editingRow === id ? (
                                <input
                                  className="text-center"
                                  type="number"
                                  value={updatePolicy.carry_forward_leaves}
                                  onChange={(e) =>
                                    setUpdatePolicy((prev) => {
                                      return {
                                        ...prev,
                                        carry_forward_leaves: e.target.value,
                                      };
                                    })
                                  }
                                />
                              ) : (
                                carry_forward_leaves
                              )}
                            </td>
                          </tr>
                        )
                      )}
                    <tr>
                      <td className="border-r">
                        <input
                          className="border-[#dbdbdb] mx-2 py-2 border rounded-md text-center placeholder:text-center focus:outline-none newsetup3 outline-none"
                          placeholder="New Policy Type"
                          value={leavePolicyType}
                          onChange={(e) => setLeavePolicyType(e.target.value)}
                          type="text"
                        />
                      </td>
                      <td className="border-r">
                        <input
                          className="border-[#dbdbdb] mx-2 py-2 border rounded-md text-center placeholder:text-center focus:outline-none newsetup3 outline-none"
                          placeholder="Set Allowed Leaves"
                          value={allowedLeavesPerYear}
                          onChange={(e) =>
                            setAllowedLeavePerYear(e.target.value)
                          }
                          type="text"
                        />
                      </td>
                      <td className="border-r">
                        <input
                          className="border-[#dbdbdb] mx-2 py-2 border rounded-md w-2/3 text-center placeholder:text-center focus:outline-none newsetup3 outline-none"
                          placeholder="Set Carry Forward Leaves"
                          value={carryForwardLeaves}
                          onChange={(e) =>
                            setCarryForwardLeaves(e.target.value)
                          }
                          type="text"
                        />
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </TabPanel>
          </Tabs>
          <div className="text-center">
            <button
              disabled={isLoading}
              onClick={(e) =>
                editingRow === null
                  ? createLeavePolicy(e)
                  : updateLeavePolicy(e)
              }
              className={
                "second-btn mt-[14px] ml-[14px] " +
                (isLoading && "opacity-50 cursor-not-allowed animate-pulse")
              }
            >
              Update Details
            </button>
          </div>
        </div>
      </Modal>
      {/* when onclick leave policies
       */}
      <Modal
        isOpen={isOpenLeaveRequestModal}
        onAfterOpen={afterOpenLeaveRequestModal}
        onRequestClose={closeOpenLeaveRequestModal}
        // style={customStyles}
        contentLabel="Example Modal"
        className="top-[50%] bottom-auto left-[50%] absolute bg-[#fff] shadow-cs p-[0px] rounded-[10px] w-[96%] xl:w-[40%] h-[auto] translate-x-[-50%] translate-y-[-50%]"
      >
        <h2
          ref={(_subtitle) => (subtitle = _subtitle)}
          className="bg-[#fff] p-3 border-b rounded-b-none rounded-r-lg rounded-t-lg text-[14px] text-left"
        >
          Pending Requests
        </h2>
        <button
          onClick={closeOpenLeaveRequestModal}
          className="top-[3px] right-[5px] absolute bg-[#27004a] rounded-full font-semibold"
        >
          <CloseIcon className="text-white" />
        </button>
        <div className="pb-2">
          <div className="mx-auto p-4 w-full max-w-6xl">
            <div className="flex mb-4">
              <button
                className={`py-2 px-2 text-[13px] font-medium whitespace-nowrap ${
                  activeTab === "leave-requests"
                    ? "text-[#27004a] border-b-2 border-[#27004a]"
                    : "text-gray-500"
                }`}
                onClick={() => setActiveTab("leave-requests")}
              >
                Leave Requests
              </button>
              {/* <button
                className={`py-2 px-2 text-[13px]  font-medium whitespace-nowrap ${activeTab === "device-verification"
                  ? "text-[#27004a] border-b-2 border-[#27004a]"
                  : "text-gray-500"
                  }`}
                onClick={() => setActiveTab("device-verification")}
              >
                Device Verification Requests
              </button> */}
            </div>

            {activeTab === "leave-requests" && (
              <div>
                {/* <div className="flex space-x-2 mb-4">
                  <button
                    className={`py-1 px-4 rounded-[10px] ${activeSubTab === "pending"
                      ? "bg-[#27004a] text-white"
                      : "bg-gray-200 text-gray-700"
                      }`}
                    onClick={() => setActiveSubTab("pending")}
                  >
                    Pending
                  </button>
                  <button
                    className={`py-1 px-4 rounded-[10px] ${activeSubTab === "history"
                      ? "bg-[#27004a] text-white"
                      : "bg-gray-200 text-gray-700"
                      }`}
                    onClick={() => setActiveSubTab("history")}
                  >
                    History
                  </button>
                </div> */}
                {/* <div className="relative col-span-1 md:col-span-2">
                  <input
                    type="text"
                    placeholder="Search staff by name"
                    className="mb-[16px] py-[4px] pr-[30px] pl-2 border rounded-[10px] w-full text-grey-700 focus-visible:outline-none"
                  />
                  <SearchIcon className="top-[6px] right-[8px] absolute text-[#808080] cursor-pointer" />
                </div>

                <div className="flex md:flex-row xl:flex-row 2xl:flex-row flex-col flex-wrap justify-between gap-[14px] mb-2 w-[100%] whitespace-nowrap">
                  <div className="relative basis-[48%]">
                    <select className="py-[4px] border rounded-[10px] w-full focus-visible:outline-none">
                      <option>Select Branch </option>
                      {branchData?.map((item) => {
                        return <option>{item?.branchName}</option>;
                      })}
                    </select>
                  </div>
                  <div className="relative basis-[48%]">
                    <select className="py-[4px] border rounded-[10px] w-full focus-visible:outline-none">
                      <option>Department</option>
                      <option>HR</option>
                      <option>IT</option>
                    </select>
                  </div>
                  <div className="flex justify-end w-full">
                    <input
                      type="date"
                      onClick={(e) => e.target.showPicker()}
                      placeholder="Select Month"
                      className="px-2 py-[4px] border rounded-md w-full text-[15px] text-gray-700 appearance-none focus-visible:outline-none"
                    ></input>
                  </div>
                </div> */}
                <div className="pb-[10px] w-full overflow-x-scroll">
                  <table className="border-[#dbdbdb] mt-4 border rounded-md table-section">
                    <thead className="top-[-1px] sticky border-[#dbdbdb] bg-white border cursor-pointer">
                      <tr>
                        <th>Leave Type</th>
                        <th>Status</th>
                        <th>Start Date</th>
                        <th>End Date</th>
                        <th>Request Date</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {fetchAllLeaveRequest?.map(
                        ({
                          id,
                          leavePolicy,
                          status,
                          start_date,
                          end_date,
                          request_date,
                        }) => (
                          <tr className="border border-[#dbdbdb]" key={id}>
                            <td className="border-r whitespace-nowrap">
                              {leavePolicy?.name}
                            </td>
                            <td className="border-r whitespace-nowrap">
                              {saveLeaveRequestEdit === id ? (
                                // <input
                                //   className="text-center"
                                //   type="text"
                                //   value={editLeaveStatus}
                                //   onChange={(e) =>
                                //     setEditLeaveStatus(e.target.value)
                                //   }
                                // />
                                <select
                                  onChange={(e) =>
                                    setEditLeaveStatus(e.target.value)
                                  }
                                >
                                  <option value="PENDING">Pending</option>
                                  <option value="APPROVED">Approved</option>
                                  <option value="REJECTED">Rejected</option>
                                </select>
                              ) : (
                                status
                              )}
                            </td>
                            <td className="border-r whitespace-nowrap">
                              {saveLeaveRequestEdit === id ? (
                                <input
                                  className="text-center"
                                  type="date"
                                  value={editLeaveStartDate} // Ensure you have the date format handled
                                  onChange={(e) =>
                                    setEditLeaveStartDate(e.target.value)
                                  }
                                />
                              ) : (
                                formatDate(start_date)
                              )}
                            </td>
                            <td className="border-r whitespace-nowrap">
                              {saveLeaveRequestEdit === id ? (
                                <input
                                  className="text-center"
                                  type="date"
                                  value={editLeaveEndDate} // Ensure you have the date format handled
                                  onChange={(e) =>
                                    setEditLeaveEndDate(e.target.value)
                                  }
                                />
                              ) : (
                                formatDate(end_date)
                              )}
                            </td>
                            <td className="border-r whitespace-nowrap">
                              {saveLeaveRequestEdit === id ? (
                                <input
                                  className="text-center"
                                  type="date"
                                  onClick={(e) => e.target.showPicker()}
                                  value={editLeaveRequestDate} // Ensure you have the date format handled
                                  onChange={(e) =>
                                    setEditLeaveRequestDate(e.target.value)
                                  }
                                />
                              ) : (
                                formatDate(request_date)
                              )}
                            </td>
                            <td className="flex justify-evenly items-center text-center border-r whitespace-nowrap">
                              {saveLeaveRequestEdit === id ? (
                                <p
                                  className="second-btn flex items-center"
                                  onClick={(e) => {
                                    editLeaveRequest(e, id);
                                  }}
                                >
                                  Save
                                </p>
                              ) : (
                                <>
                                  <p
                                    className="font-bold  text-[#27004a] cursor-pointer"
                                    onClick={(e) => {
                                      e.preventDefault();
                                      setSaveLeaveRequestEdit(id);
                                      setEditLeaveID(leavePolicy?.id);
                                      setEditLeaveRequestDate(
                                        formatDateToInput(request_date)
                                      );
                                      setEditLeaveEndDate(
                                        formatDateToInput(end_date)
                                      );
                                      setEditLeaveStartDate(
                                        formatDateToInput(start_date)
                                      );
                                      setEditLeaveStatus(status);
                                    }}
                                  >
                                    <FaEdit className="text-[16px]" />
                                  </p>
                                  <p
                                    className="font-bold text-red-500 cursor-pointer"
                                    onClick={(e) => {
                                      e.preventDefault();
                                      console.log(id);
                                      setDeleteLeaveID(id);
                                      deleteLeaveRequest(e, id);
                                    }}
                                  >
                                    <MdDelete className="text-[16px]" />
                                  </p>
                                </>
                              )}
                            </td>
                          </tr>
                        )
                      )}
                    </tbody>
                  </table>
                </div>
                {/* <tr>
                                            <td><input className='border-slate-400 mx-2 py-2 border text-center placeholder:text-center focus:outline-none outline-none' placeholder='New Policy Type' value={leavePolicyType} onChange={(e) => setLeavePolicyType(e.target.value)} type='text' /></td>
                                            <td><input className='border-slate-400 mx-2 py-2 border text-center placeholder:text-center focus:outline-none outline-none' placeholder='Set Allowed Leaves' value={allowedLeavesPerYear} onChange={(e) => setAllowedLeavePerYear(e.target.value)} type='text' /></td>
                                            <td><input className='border-slate-400 mx-2 py-2 border w-2/3 text-center placeholder:text-center focus:outline-none outline-none' placeholder='Set Carry Forward Leaves' value={carryForwardLeaves} onChange={(e) => setCarryForwardLeaves(e.target.value)} type='text' /></td>
                                        </tr> */}
              </div>
            )}

            {activeTab === "device-verification" && (
              <div className="py-16 text-center">
                <p className="font-medium text-gray-600 text-lg">
                  Device Verification Content
                </p>
              </div>
            )}
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default EditLeavePolicies;
